import { TeacherType } from 'constants/teacherRecruitment';
import { TApiResponse } from '@type/common';
import { AxiosInstance } from 'axios';
import { IPagnationParams, TSBApiResponse } from 'src/@type/common';
import {
  TeacherRecruitmentDto,
  ISearchFieldReferrer,
  IReferrerListResponse,
  IExportReferrer,
} from '@type/teacherRecruitment';

export interface IScheduleParams {
  startTime: number;
  endTime: number;
}
export interface ICreateScheduleParams {
  startTime: number;
  endTime: number;
  userId: string;
}
export interface IDeleteScheduleParams {
  remarks: string;
}

export interface IBitrixParams {
  id: string;
}

export interface ITutorials {
  userId: string;
  name: string;
  education: string;
  subject: string;
  project: string;
  projectId: string;
  isForced: boolean;
  startTime: number;
  endTime: number;
  remarks: string;
  year: string;
  usagePeriodStatus: string;
  courseName: string;
  tutorialName: string;
  crmId: string;
  bookId: string;
  advisor: string;
  advisorId: string;
  audiovisualNumber: string;
  classType: string;
}
export interface TRContractEditor {
  name?: string;
  email?: string;
  staffNumber?: string;
}

export interface TeacherRecruitmentContract {
  id: string;
  name: string;
  description?: string;
  editor?: TRContractEditor;
  content: string;
  createdAt: string;
  updatedAt: string;
  isDraft: boolean;
  isNewest?: boolean;
}

export interface TRContractVariable {
  id: string;
  name: string;
  htmlContent: string;
  placeHolderHtml: string;
  defaultValue: string;
}

export enum ContractType {
  EMPLOYMENT_CONTRACT = 'employment',
  TERMINATED_CONTRACT = 'terminated',
}

export interface IContractListQueryParams extends IPagnationParams {
  contractType: ContractType;
}

export interface IGetContractQueryParams {
  contractType: ContractType;
}
export interface MigrateTeacherBody {
  oneClubId: string;
  firstName: string;
  lastName: string;
  nickName: string;
  gender: string;
  staffType: string;
  status: string;
  email: string;
  mobile?: string | null;
  mobileCountryCode?: string | null;
  telephone?: string | null;
  telephoneCountryCode?: string | null;
  teacherStaffID?: string | null;
  nationality: string;
  turnOfficialTime: string;
  isTurnOnCrossSubjectUI?: boolean;
  teacherType?: TeacherType;
}

export interface MigrateTeacherResponse {
  id: string;
  oneClubId: string;
  firstName: string;
  lastName: string;
  nickName: string;
  gender: string;
  staffType: string;
  status: string;
  email: string;
  mobile?: string | null;
  telephone?: string | null;
  teacherStaffID?: string | null;
  teacherType?: TeacherType;
}

export default (axios: AxiosInstance, teacher: string) => ({
  /**
   * 取得老師清單
   */
  getTeacherInterviewList(data: any): TApiResponse<any> {
    return axios.get(`${teacher}/applied-teacher-list`, { params: data });
  },

  getTeacherUnverifiedList(data: any): TApiResponse<any> {
    return axios.get(`${teacher}/unverified-teacher-list`, { params: data });
  },
  getDetailApplicant(id: string): TApiResponse<any> {
    return axios.get(`${teacher}/${id}`);
  },
  updateReview(id: string, payload: any): TApiResponse<any> {
    return axios.post(`${teacher}/update-interview-status/${id}`, payload);
  },
  updateById(id: string, payload: any): TApiResponse<any> {
    return axios.patch(`${teacher}/byId/${id}`, payload);
  },
  promoteToOfficialTeacher(id: string): TApiResponse<any> {
    return axios.post(`${teacher}/set-official-teacher/${id}`);
  },

  getInfoByOneClubId(oneClubId: string): TApiResponse<TeacherRecruitmentDto> {
    return axios.get(`${teacher}/oneClubId/${oneClubId}`);
  },
  getReferrerList(
    data: ISearchFieldReferrer,
  ): TApiResponse<IReferrerListResponse> {
    return axios.get(`${teacher}/official-teachers-with-referral-code`, {
      params: data,
    });
  },
  exportRecommendationTeacherList(data: IExportReferrer): TApiResponse<string> {
    const params = new URLSearchParams({
      dateTo: data.dateTo,
      dateFrom: data.dateFrom,
    });

    return axios.get(
      `${teacher}/export-recommendation-teacher-list-data/?${params.toString()}`,
    );
  },
  migrateTeacher(
    data: MigrateTeacherBody,
  ): TApiResponse<MigrateTeacherResponse> {
    return axios.patch(`${teacher}`, data);
  },
});
